import type { IOfficeFileLinkHandlingInfo, IOfficeLinkInfo } from 'flora-types';
import { GetOfficeFileLinkHandlingInfo } from './GetOfficeFileLinkHandlingInfo';
import { logUsage } from 'owa-analytics';

async function GetOfficeLinkInfo(url: string): Promise<IOfficeLinkInfo | undefined> {
    const officeFileLinkHandlingInfo: IOfficeFileLinkHandlingInfo | undefined =
        await GetOfficeFileLinkHandlingInfo();
    if (officeFileLinkHandlingInfo) {
        const officeLinkInfo: IOfficeLinkInfo =
            await officeFileLinkHandlingInfo.GetLinkOpenOptionInfo(
                url,
                'monarch' // appId
            );

        if (officeLinkInfo) {
            const isEligible: boolean = await officeLinkInfo.IsEligible();

            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logUsage('GetOfficeLinkInfo', undefined, { isEligible });

            if (isEligible) {
                return officeLinkInfo;
            }
        }
    }

    return undefined;
}

export async function GetUrlToOpenUsingDefault(url: string): Promise<string | undefined> {
    const officeLinkInfo: IOfficeLinkInfo | undefined = await GetOfficeLinkInfo(url);
    if (officeLinkInfo) {
        const urlToOpenUsingDefault: string = await officeLinkInfo.UrlToOpenUsingDefault();
        const clickCorrelationId: string = await officeLinkInfo.LatestClickCorrelationId();

        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logUsage('GetUrlToOpenUsingDefault', undefined, { clickCorrelationId });

        return urlToOpenUsingDefault;
    }

    return undefined;
}
